import { StepStatus } from '@/app/components/Modal/StepIcon';

interface StatusParams {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  overrideSuccess?: boolean;
}

export const getStepStatus = ({
  isLoading,
  isSuccess,
  isError,
  overrideSuccess = false,
}: StatusParams): StepStatus => {
  if (isLoading) return StepStatus.Loading;
  if (isSuccess || overrideSuccess) return StepStatus.Success;
  if (isError) return StepStatus.Error;
  return StepStatus.Pending;
};
